import type { ApiRoute, NoQueryParams, NoResponse } from "../api"

export interface PostFeedbackBody {
	rating: 1 | 2 | 3 | 4 | 5
	roles?: string[]
	text?: string
	url: string
}

export const postFeedbackRoute: ApiRoute<NoQueryParams, NoQueryParams, PostFeedbackBody, NoResponse> = {
	buildUrl: () => "/feedback",
	method: "post",
	path: "/feedback",
}
